import { useEffect, useState } from "react";
import AdminFormLayout, { FormSection } from "../../components/common/form-layout/AdminFormLayout";
import { getApi, putApi } from "../../services/api/globalApi";
import { useAdminAccess } from "../../layout/access/AdminAccessContext";

const path = "admin/settings/warehouse-permissions";
export default function AccessSettings() {
  const { menu, reportTypes } = useAdminAccess();
  const [permissions, setPermissions] = useState(null);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const load = async () => {
    setError(""); setPermissions(null);
    try {
      const response = await getApi({ path });
      const value = response?.data?.result;
      if (!Array.isArray(value?.sidebar) || !Array.isArray(value?.dashboardReports)) throw new Error("invalid permissions");
      setPermissions(value);
    } catch (_) { setError("دریافت تنظیمات دسترسی انجام نشد."); }
  };
  useEffect(() => { load(); }, []);
  const toggle = (field, ids, checked) => {
    setSaved(false);
    setPermissions(current => ({ ...current, [field]: checked ? [...new Set([...current[field], ...ids])] : current[field].filter(id => !ids.includes(id)) }));
  };
  const save = async event => {
    event.preventDefault(); setSaving(true); setSaved(false); setError("");
    try {
      const response = await putApi({ path, body: permissions });
      setPermissions(response.data.result); setSaved(true);
    } catch (_) { setError("ذخیره دسترسی‌ها انجام نشد. دوباره تلاش کنید."); }
    finally { setSaving(false); }
  };
  return <AdminFormLayout title="تنظیمات سطح دسترسی‌ها" description="دسترسی نقش انباردار را برای همه کاربران این نقش تنظیم کنید. تغییرات پس از ذخیره اعمال می‌شوند.">
    <div className="mb-5 rounded-xl border border-blue-200 bg-blue-50 p-4 text-blue-900">نقش: <strong>انباردار</strong><p className="mt-2 text-sm">تنها گزینه‌های انتخاب‌شده نمایش داده می‌شوند. برای تعیین گزارش‌ها، دسترسی «داشبورد» را هم فعال کنید. مدیریت نقش‌ها و حساب‌های مدیریتی در اختیار ادمین است.</p></div>
    {error && <p role="alert" className="mb-4 text-red-700">{error} {!permissions && <button type="button" onClick={load} className="mr-3 underline">تلاش دوباره</button>}</p>}
    {!permissions ? !error && <p role="status">در حال دریافت تنظیمات…</p> : <form onSubmit={save}>
      <fieldset disabled={saving}>
        <FormSection title="آیتم‌های سایدبار">
          <div className="grid gap-4 p-4 md:grid-cols-2 xl:grid-cols-3">
            {menu.map(group => {
              const ids = group.items.map(item => item.id);
              const count = ids.filter(id => permissions.sidebar.includes(id)).length;
              return <div key={group.id} className="rounded-xl border border-slate-200 p-4">
                <label className="flex items-center gap-3 font-bold"><input type="checkbox" checked={count === ids.length} ref={node => { if (node) node.indeterminate = count > 0 && count < ids.length; }} onChange={event => toggle("sidebar", ids, event.target.checked)} aria-label={`همه موارد ${group.label}`} />{group.label}</label>
                <div className="mt-3 space-y-3 pr-4">{group.items.map(item => <label key={item.id} className="flex items-center gap-3 text-sm"><input type="checkbox" checked={permissions.sidebar.includes(item.id)} onChange={event => toggle("sidebar", [item.id], event.target.checked)} />{item.label}</label>)}</div>
              </div>;
            })}
          </div>
        </FormSection>
        <FormSection title="گزارش‌های داشبورد">
          <div className="space-y-4 p-4">{reportTypes.map(item => <label key={item.id} className="flex items-center gap-3"><input type="checkbox" checked={permissions.dashboardReports.includes(item.id)} onChange={event => toggle("dashboardReports", [item.id], event.target.checked)} />{item.label}</label>)}</div>
          {!permissions.sidebar.includes("/") && <p className="p-4 text-sm text-amber-800">برای نمایش گزارش‌های انتخاب‌شده، گزینه داشبورد را در سایدبار فعال کنید.</p>}
        </FormSection>
        <button type="submit" className="mt-6 rounded-xl bg-blue-700 px-6 py-3 text-white disabled:opacity-50">{saving ? "در حال ذخیره…" : "ذخیره دسترسی‌ها"}</button>
      </fieldset>
      {saved && <p role="status" className="mt-4 text-green-700">دسترسی‌های انباردار با موفقیت ذخیره شد.</p>}
    </form>}
  </AdminFormLayout>;
}
